import React from "react";
function PageNotFound() {

    return (
        <div id="wrapper">
            <img className="mx-auto d-block img-fluid" src="https://i.imgur.com/qIufhof.png" width="200" height="200" alt="not found"/>
            <div className="spacer" ></div>
        </div >
    )
}

export default PageNotFound;